"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_components_form_radio_group_1 = require("@saatva-bits/pattern-library.components.form-radio-group");
const pattern_library_components_form_toggle_1 = require("@saatva-bits/pattern-library.components.form-toggle");
const ProductLabel_1 = __importDefault(require("../ProductLabel/ProductLabel"));
const selection_hooks_1 = require("../../../../selection.hooks");
const selection_utils_1 = require("../../../../selection.utils");
const ProductSelectToggle_module_scss_1 = __importDefault(require("./ProductSelectToggle.module.scss"));
/**
 *
 * @param {Object} props
 * @param {string} props.className
 * @param {string} props.productCode
 * @param {string} props.attributeCode
 * @param {Object.<string, string>} props.toggleProps
 * @param {string} props.dataSelector
 * @param {boolean} props.displayLabel
 * @param {boolean} props.isOutOfStockStyling
 * @returns {import('react').ReactNode}
 */
const ProductSelectToggle = ({ className, productCode, attributeCode, toggleProps, dataSelector, displayLabel = true, isOutOfStockStyling }) => {
    const productData = (0, selection_hooks_1.useProductData)(productCode);
    const options = (0, selection_hooks_1.useAttributeOptions)(productCode, attributeCode);
    const optionElements = options && options.values.map((value) => {
        const element = {
            label: (toggleProps === null || toggleProps === void 0 ? void 0 : toggleProps.modifyOptionLabel) ? toggleProps.modifyOptionLabel(value.label) : value.label,
            value: value.code
        };
        if (isOutOfStockStyling) {
            const variantsWithAttributeValue = (0, selection_utils_1.findVariantsWithAttributeValue)(productData, options.code, value.code);
            const isInStock = variantsWithAttributeValue === null || variantsWithAttributeValue === void 0 ? void 0 : variantsWithAttributeValue.find(variant => variant.inStock);
            element.childProps = { isOutOfStock: !isInStock };
        }
        return element;
    });
    const labelText = `Select ${options.displayName.toLowerCase()}`;
    const onChange = (selectedItem) => {
        options.setAttributeValue(selectedItem);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { "data-selector": dataSelector, children: [displayLabel &&
                (0, jsx_runtime_1.jsx)(ProductLabel_1.default, { index: 0, label: labelText, isCustomLabel: true, modalContentProps: { productCode, sku: productCode }, ...toggleProps }), (0, jsx_runtime_1.jsx)(pattern_library_components_form_radio_group_1.FormRadioGroup, { className: className, name: `product-option-${attributeCode}`, dataSrc: optionElements, initialSelection: options.selectedValue, onSelectionUpdate: onChange, children: (0, jsx_runtime_1.jsx)(pattern_library_components_form_toggle_1.FormToggle, { className: ProductSelectToggle_module_scss_1.default.formToggle, selectedClassName: ProductSelectToggle_module_scss_1.default['formToggle-isSelected'], dataSelectorPrefix: `${attributeCode}Toggle` }) }, `radio-group-${options.selectedValue}`)] }));
};
ProductSelectToggle.propTypes = {
    className: prop_types_1.default.string,
    productCode: prop_types_1.default.string,
    attributeCode: prop_types_1.default.string,
    toggleProps: prop_types_1.default.object,
    dataSelector: prop_types_1.default.string,
    displayLabel: prop_types_1.default.bool,
    isOutOfStockStyling: prop_types_1.default.bool
};
exports.default = ProductSelectToggle;
//# sourceMappingURL=ProductSelectToggle.js.map